export const MOCK_SITES = [
  { site_id: 'site-001', site_name: 'Downtown Office' },
  { site_id: 'site-002', site_name: 'Warehouse North' },
  { site_id: 'site-003', site_name: 'Community Tower A' },
];

export const MOCK_EMPLOYEES = [
  {
    user_id: 'emp-001',
    employee_id: 'EMP0001',
    display_name: 'John Smith',
  },
  {
    user_id: 'emp-002',
    employee_id: 'EMP0002',
    display_name: 'Sarah Johnson',
  },
  {
    user_id: 'emp-003',
    employee_id: 'EMP0003',
    display_name: 'Michael Chen',
  },
  {
    user_id: 'emp-004',
    employee_id: 'EMP0004',
    display_name: 'Priya Sharma',
  },
  {
    user_id: 'emp-005',
    employee_id: 'EMP0005',
    display_name: 'David Wilson',
  },
];

export const MOCK_GROUPS = [
  {
    id: 'group-001',
    site_id: 'site-001',
    site_name: 'Downtown Office',
    group_name: 'Security Team',
    level: 'site',
    group_guid: 'guid-site-001',
    shift_sync_active: true,
    last_synced_at: '2 hr ago',
  },
  {
    id: 'group-002',
    site_id: 'site-002',
    site_name: 'Warehouse North',
    group_name: 'Operations',
    level: 'site',
    group_guid: null,
    shift_sync_active: false,
    last_synced_at: null,
  },
];

export const getInitials = name => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};
